// ancestorChain returns the ids of a node's ancestors, nearest first, up to but excluding the
// virtual "root". Used to reveal a node (un-collapse the branches above it) when jumping to it
// from search. parentById maps a child id to its parent id ("root" for top-level nodes).
export function ancestorChain(nodeId, parentById) {
  const chain = [];
  const seen = new Set();
  let current = parentById[nodeId];
  while (current != null && current !== "root" && !seen.has(current)) {
    seen.add(current);
    chain.push(current);
    current = parentById[current];
  }
  return chain;
}
